<template>
<div class="civii-camera" v-if="cameraWidget">
  <video v-show="photoData == null" ref="video" class="video">Video stream not available.</video>
  <div class="button" @click="takePicture" v-show="photoData == null"/>
  <canvas ref="canvas" class="canvas" />
  <img ref="photo" v-show="photoData != null" class="photo">
  <div class="buttons" v-show="photoData != null">
    <div class="retake" @click="retake">
      <div class="return" />
    </div>
    <div class="confirmar" @click="accept">
      <div />
    </div>
  </div>
</div>
</template>

<script>
import cancelaccept from './../CancelAccept/CancelAccept.vue'

export default {
  components: {
    cancelaccept
  },
  data () {
    return {
      streaming: false,
      photoData: null,
      stream: null
    }
  },
  methods: {
    streamConf (stream) {
      this.$refs.video.srcObject = stream
      this.$refs.video.play()
    },
    startStreaming (ev) {
      try {
        if (!this.streaming) {
          let width = this.$refs.video.offsetWidth
          let factor = width / this.$refs.video.videoWidth
          let height = this.$refs.video.videoHeight * factor

          this.$refs.video.setAttribute('width', width)
          this.$refs.video.setAttribute('height', height)
          this.$refs.canvas.setAttribute('width', this.$refs.video.videoWidth)
          this.$refs.canvas.setAttribute('height', this.$refs.video.videoHeight)
          this.streaming = true
        }
      } catch (e) {}
    },
    init () {
      this.photoData = null
      this.streaming = false
      navigator.getMedia = (navigator.getUserMedia ||
        navigator.webkitGetUserMedia || navigator.mozGetUserMedia ||
        navigator.msGetUserMedia
      )
      // eslint-disable-next-line
      let self = this
      navigator.getMedia({video: true, audio: false}, this.streamConf,
        (err) => self.cameraError(err))
      this.$refs.video.addEventListener('canplay', this.startStreaming, false)
    },
    init_ () {
      this.init()
      document.removeEventListener('click', this.init_)
    },
    takePicture () {
      var context = this.$refs.canvas.getContext('2d')
      if (this.streaming) {
        context.drawImage(this.$refs.video, 0, 0, this.$refs.video.videoWidth,
          this.$refs.video.videoHeight)

        this.photoData = this.$refs.canvas.toDataURL('image/jpeg')
        this.$refs.photo.setAttribute('src', this.photoData)
        this.stop()
      }
    },
    retake () {
      this.photoData = null
      this.streaming = false
      this.init()
    },
    stop () {
      try {
        this.$refs.video.srcObject.getVideoTracks().forEach(function (track) {
          track.stop()
        })
      } catch (e) {}
    },
    async accept () {
      this.$store.commit('addToContext', {'_input': this.photoData})
      await this.$store.dispatch('sendMessage', {})
    },
    async cancel () {
      this.$store.commit('addToContext', {'_input': false})
      await this.$store.dispatch('sendMessage', {})
    },
    async cameraError (err) {
      this.$store.commit('addToContext', {'_input': {error: err}})
      await this.$store.dispatch('sendMessage', {})
    }
  },
  computed: {
    cameraWidget () {
      return this.$store.state.cameraWidget
    }
  },
  watch: {
    cameraWidget (value) {
      if (value) {
        let self = this
        this.$nextTick(function () {
          self.init()
        })
      } else {
        this.stop()
      }
    }
  },
  mounted () {
    if (this.cameraWidget) {
      document.addEventListener('click', this.init_)
    }
  },
  destroyed () {
    this.stop()
  }
}
</script>

<style lang="less">
.civii-camera {
  position: relative;
  max-width: 400px;
  .button {
    left: 50%;
    transform: translateX(-50%);
    position: absolute;
    bottom: 10px;
    background-color: rgb(172, 172, 172);
    border: 5px solid rgb(83, 83, 83);
    border-radius: 50%;
    cursor: pointer;
    width: 60px;
    height: 60px;
    display: block;
    &:hover {
      background-color: rgb(197, 197, 197);
      border: 5px solid rgb(110, 110, 110);
    }
  }

  .canvas {
    display: none;
  }

  .video {
    width: 100%;
    height: auto;
  }

  .photo {
    width: 100%;
    height: auto;
  }
  @icon-size: 25px;
  .buttons {
    display: flex;
    align-items: center;
    .retake {
      margin-right: 1px;
      flex: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: #4588cb;
      border-radius: 0px 0px 0px 5px;
      padding: 5px;
      cursor: pointer;
      .return {
        height: @icon-size;
        width: @icon-size;
        border: @icon-size/4 solid rgb(255, 255, 255);
        border-bottom: @icon-size/4 solid rgba(0,0,0,0);
        border-radius: 50%;
        box-sizing: border-box;
        position: relative;
        &:before {
          content: "";
          height: 0px;
          width: 0px;
          position: absolute;
          border: @icon-size/3 solid rgba(0,0,0,0);
          border-top: @icon-size/3 solid rgb(255, 255, 255);
          transform: rotate(-45deg);
          bottom: -@icon-size/2;
          left: -@icon-size/6;
        }
      }
    }
    .confirmar {
      margin-left: 1px;
      flex: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: #00cb5c;
      border-radius: 0px 0px 5px 0px;
      padding: 5px;
      cursor: pointer;
      &>div {
        height: @icon-size;
        width: @icon-size*1.2;
        box-sizing: border-box;
        position: relative;
        &:before {
          content: "";
          height: @icon-size*0.6;
          width: @icon-size;
          position: absolute;
          border-left: @icon-size*0.25 solid rgb(255, 255, 255);
          border-bottom: @icon-size*0.25 solid rgb(255, 255, 255);
          transform: rotate(-45deg);
          bottom: @icon-size*0.3;
          left: @icon-size*0.15;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/widgets/CameraWidget/CameraWidget.vue